import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import * as Atom from '../recoil';
import { beaconSelector } from '../recoil/selector';
import { validateYearMonthDay } from '../helper/validator';
import useBeacon, { IClkBtnOptionProperties } from '../hooks/useBeacon';
import { PAGE_NM } from '../types/types';

export const useMtgIncome = () => {
  const beaconData = useRecoilValue(beaconSelector);
  const beacon = useBeacon({
    mediaCd: beaconData.mediaCd,
    custSeq: beaconData.custSeq,
    srcCd: beaconData.srcCd,
    pageName: PAGE_NM.MTG_INCOME,
  });
  const sendBeaconClkBtnOption = ({
    btmsheet_name,
    option_name,
    before_option_name,
  }: IClkBtnOptionProperties) => {
    beacon.sendClkBtnOption({
      properties: <IClkBtnOptionProperties>{
        btmsheet_name: btmsheet_name,
        option_name: option_name,
        before_option_name: before_option_name,
      },
    });
  };

  const sendBeaconClkBtn = (subEventName: string, props: any) => {
    beacon.sendClkBtn(
      {
        events: {
          subEventName: subEventName,
        }, 
        properties: props
      }
    );
  }

  useEffect(() => {
    beacon.sendViewPage();
  }, []);

  const [mortgageInfo] = useRecoilState(Atom.mortgageInfo);
  const [isActive, setActive] = useState<boolean>(false);
  const [openDtWarning, setOpenDtWarning] = useState<string>("");


  const checkOpenDt = (value: string): boolean => {
    if (!value)
      return false;
    const openDt = value.replace(/\./g, '');
    if (openDt.length != 8)
      return false;

    return true;
  }

  useEffect(() => {
    if (mortgageInfo.marriageCd.value && mortgageInfo.jobType.value && mortgageInfo.salaryAmt) {
      if (mortgageInfo.jobType.value === '04' && !checkOpenDt(mortgageInfo.openDt.value)) {
        setActive(false);
      } else {
        setActive(true);
      }
    } else {
      setActive(false);
    }
  }, [mortgageInfo]);

  const validateJobDate = (date?: string) => {
    if (!date || date.length < 8) {
      setOpenDtWarning('');
      return true;
    }

    const openDt = date.replace(/\./g, '');
    if (openDt.length === 8) {
      const year = openDt.substring(0, 4);
      const month = openDt.substring(4, 6);
      const day = openDt.substring(6);
      const maxDate = new Date();
      const minDate = new Date('1900-01-01');
      const theDate = new Date(`${year}-${month}-${day}`);

      if (isNaN(Number(theDate)) || minDate >= theDate) {
        setOpenDtWarning('입력 날짜를 다시 확인해 주세요');
        return false;
      } else if (theDate > maxDate) {
        setOpenDtWarning('오늘 이후 날짜를 입력할 수 없어요');
        return false;
      }
      document.getElementById('txtSalaryAmt')?.focus();
    } else if (openDt.length > 8) {
      return false;
    }
    setOpenDtWarning('');
    return true;
  };

  const onBlurOpenDt = (e: any) => {
    let value = e.target.value;
    if (!checkOpenDt(value)) {
      setOpenDtWarning("개업일자를 다시 확인해 주세요");
    }
  }

  return {
    isActive,
    openDtWarning,
    validateJobDate,
    sendBeaconClkBtnOption,
    onBlurOpenDt,
    sendBeaconClkBtn,
  };
};
